import { render } from "./shareChannelDetail.vue?vue&type=template&id=9d209310&scoped=true"
import script from "./shareChannelDetail.vue?vue&type=script&lang=js"
export * from "./shareChannelDetail.vue?vue&type=script&lang=js"

import "./shareChannelDetail.vue?vue&type=style&index=0&id=9d209310&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d209310"],['__file',"src/views/channel/components/shareChannelDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d209310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d209310', __exports__)) {
    console.log('reload')
    api.reload('9d209310', __exports__)
  }
  
  module.hot.accept("./shareChannelDetail.vue?vue&type=template&id=9d209310&scoped=true", () => {
    console.log('re-render')
    api.rerender('9d209310', render)
  })

}


export default __exports__